<template>
  <div id="topBar">
    <header class="header">
      <h1 class="h1">
        <span class="goBack" @click="goBack" v-if="showBack">
          <svg-icon iconClass="left"></svg-icon>
        </span>
        {{title}}
        <span class="subTitle">{{subTitle}}</span>
      </h1>

    </header>
  </div>
</template>
<script>
  export default {
    name:'topBar',
    props:{
      title:'',
      subTitle:'',
      query:{},
      showBack:{
        type: Boolean,
        default: true
      }
    },
    data(){
      return{

      }
    },
    methods:{
      goBack(){
        this.$router.goBack()
      },
    }
  }
</script>
<style lang="less" scoped>
  #topBar{
    background: white;
    .header{
      .h1{
        position: relative;
        text-align: center;
        font-size: 18px;
        font-weight: normal;
        padding:10px 0;
        margin: 0;
        font-family: Avenir,Helvetica,Arial,sans-serif;
        line-height: 18px;
        color: #333;
      }
      .subTitle{
        font-size: 16px;
      }
      .goBack{
        position: absolute;
        left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ui/topBar/src/topBar.vue